import React from 'react'
import {withTheme} from 'styled-components'
import {getLang} from 'utils/stringUtils'
import ZFFLogos from './ZFFLogos'

const HeaderLogos = ({theme}) => {
  const lang = getLang(window.location.search) || 'de'
  const homeLink = theme.brand.url
  return <ZFFLogos theme={theme} lang={lang} homeLink={homeLink} />
}

export default withTheme(HeaderLogos)
